import React from 'react'

import { BannerRoot, BannerScore, BannerSparkle, BannerText } from './AIRationaleBanner.styled'

interface IProps {
  summary: string | null | undefined
  score?: number | null
}

// AI sparkle glyph taken verbatim from the BRAND-9367 design (Figma node 6473-6431).
// Inlined as a local SVG because the @tribegroup icon set has no AI/sparkle glyph.
// `currentColor` lets it inherit the banner's white text colour. The viewBox is the
// path's own bounding box on the source artboard so no coordinate translation is needed.
const AiSparkleIcon: React.FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="793 23 18 18"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M801.3 26.5367L801.736 28.5767C802.131 30.4254 803.575 31.8694 805.424 32.2647L807.464 32.7007C808.147 32.8467 808.147 33.8207 807.464 33.9667L805.424 34.4027C803.575 34.7981 802.131 36.2421 801.736 38.0907L801.3 40.1307C801.154 40.8134 800.18 40.8134 800.034 40.1307L799.598 38.0907C799.203 36.2421 797.759 34.7981 795.91 34.4027L793.87 33.9667C793.187 33.8207 793.187 32.8467 793.87 32.7007L795.91 32.2647C797.759 31.8694 799.203 30.4254 799.598 28.5767L800.034 26.5367C800.179 25.8541 801.154 25.8541 801.3 26.5367ZM807.761 23.6834L808.153 25.0961C808.254 25.4607 808.539 25.7461 808.904 25.8474L810.317 26.2394C810.75 26.3594 810.75 26.9741 810.317 27.0941L808.904 27.4861C808.539 27.5874 808.254 27.8727 808.153 28.2374L807.761 29.6501C807.641 30.0834 807.026 30.0834 806.906 29.6501L806.514 28.2374C806.413 27.8727 806.127 27.5874 805.763 27.4861L804.35 27.0941C803.917 26.9741 803.917 26.3594 804.35 26.2394L805.763 25.8474C806.127 25.7461 806.413 25.4607 806.514 25.0961L806.906 23.6834C807.026 23.2501 807.641 23.2501 807.761 23.6834Z"
      fill="currentColor"
    />
  </svg>
)

const AIRationaleBanner: React.FC<IProps> = ({ summary, score }) => {
  if (!summary) return null

  const hasScore = score !== null && score !== undefined

  return (
    <BannerRoot role="note" data-testid="drawer-ai-banner">
      {hasScore && <BannerScore data-testid="drawer-ai-banner-score">{score}</BannerScore>}
      <BannerText>{summary}</BannerText>
      <BannerSparkle data-testid="drawer-ai-banner-icon">
        <AiSparkleIcon />
      </BannerSparkle>
    </BannerRoot>
  )
}

export { AIRationaleBanner }
export default AIRationaleBanner
